let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iyI96")).then(() => parcelRequire('4AHSJ'));